import { useSWR } from '@tiger/swr';
import security from 'stores/security';
import API from 'utils/API';
import { BrokerData, TransferInfo } from './type';

/**
 * @description 分页接口, 用于获取经济商列表: /support/api/v1/broker/config/list
 */
export function useBrokerList(options: {
    searchBroker?: string; // 模糊搜索的经济商名称
    getAllBroker: boolean; // 这是一个分页接口, 默认每页只返回20条数据, 如果需要获取所有数据, 则需要传入true
}) {
    const { searchBroker, getAllBroker } = options;
    // 如果需要获取所有数据, 则设置每页返回99999条数据, 截止目前@2025/6/25, 线上共有140条数据
    const perPage = getAllBroker ? 99999 : 20;

    return useSWR<{ items: BrokerData[] }>(
        {
            url: API.CUSTOMER.transfer.transferBrokerSearch(),
            params: {
                direction: 'out',
                customer_type: 'individual',
                broker: searchBroker,
                per_page: perPage
            }
        },
        {
            immutable: true,
            dataChain: resp => resp.data
        }
    );
}

export function useTransferInfo() {
    return useSWR<TransferInfo>(
        !!security.currentAccountId && {
            url: API.CUSTOMER.transfer.transferInfo(),
            params: { account_id: security.currentAccountId }
        },
        {
            immutable: true,
            dataChain: resp => resp.data
        }
    );
}
